import { EnviromentZone, IHowdenEnvironment, LogLevel } from '@howdeniberia/core-front';
import { howdenGroupAzureB2cDevConfig } from './microsoft-b2c-howdengroup-dev';

export const environment = {
  zone: EnviromentZone.DEVELOPMENT_B2C,
  appIdSecurity: 0,
  logLevel: LogLevel.VERBOSE,
  openid: howdenGroupAzureB2cDevConfig
} as IHowdenEnvironment;
